(() => {
  const root = document.getElementById('rocup-meta');
  if (!root) return;

  const form = root.querySelector('#rocup-meta-form');
  const variantJson = root.querySelector('[data-variant-json]');
  const priceEl = root.querySelector('[data-price]');
  const idInput = root.querySelector('[data-variant-id]');
  const addBtn = root.querySelector('[data-add-to-cart]');

  const variants = variantJson ? JSON.parse(variantJson.textContent) : [];
  if (!variants.length) return;

  // Collect option controls (both dots, pills and size buttons)
  const optionGroups = [...root.querySelectorAll('[data-option-group]')];

  // Preselect from current hidden id (server selected_or_first_available_variant)
  let current = variants.find(v => String(v.id) === idInput.value) || variants[0];

  function renderSelectedStates() {
    optionGroups.forEach(group => {
      const idx = Number(group.querySelector('[data-selectable]')?.dataset.optionIndex);
      const val = current.options[idx];
      [...group.querySelectorAll('[data-selectable]')].forEach(el => {
        el.classList.toggle('is-selected', el.dataset.value === val);
      });
    });
    // disable sizes that are unavailable for the chosen colour
    const sizeGroup = optionGroups.find(g => Number(g.querySelector('[data-selectable]')?.dataset.optionIndex) !== undefined &&
                                             Number(g.querySelector('[data-selectable]')?.dataset.optionIndex) !== (current.options.length > 1 ? 0 : 999));
    if (sizeGroup) {
      const colour = current.options[0];
      [...sizeGroup.querySelectorAll('[data-selectable]')].forEach(btn => {
        const hypothetical = [colour, btn.dataset.value, current.options[2]].filter(Boolean);
        const match = variants.find(v => JSON.stringify(v.options.slice(0, hypothetical.length)) === JSON.stringify(hypothetical));
        const unavailable = !match || !match.available;
        btn.classList.toggle('is-disabled', unavailable);
        btn.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      });
    }
    // update price, button state
    if (priceEl) priceEl.innerHTML = Shopify.formatMoney(current.price);
    addBtn.disabled = !current.available;
    addBtn.textContent = current.available ? 'Shop Now' : 'Sold Out';
  }

  function setVariantByOptions(opts) {
    const v = variants.find(x => JSON.stringify(x.options) === JSON.stringify(opts));
    if (!v) return;
    current = v;
    idInput.value = v.id;
    // Also tell Dawn’s main-product to swap media
    const nativeSelect = document.querySelector('form[action*="/cart/add"] select[name="id"]');
    if (nativeSelect) {
      nativeSelect.value = v.id;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    renderSelectedStates();
  }

  // Click handlers for swatches, colour pills, sizes
  optionGroups.forEach(group => {
    group.addEventListener('click', e => {
      const el = e.target.closest('[data-selectable]');
      if (!el || el.classList.contains('is-disabled')) return;
      const idx = Number(el.dataset.optionIndex);
      const newOpts = current.options.slice();
      newOpts[idx] = el.dataset.value;
      setVariantByOptions(newOpts);
    });
  });

  // Qty stepper
  const minus = root.querySelector('[data-qty-minus]');
  const plus = root.querySelector('[data-qty-plus]');
  const qty = root.querySelector('[data-qty-input]');
  const clamp = n => Math.max(1, Math.min(99, n));
  if (minus && plus && qty) {
    minus.addEventListener('click', () => qty.value = clamp((+qty.value || 1) - 1));
    plus.addEventListener('click', () => qty.value = clamp((+qty.value || 1) + 1));
  }

  renderSelectedStates();
})();
